<template>
	<v-toolbar app height="40" class="media-print header-style header-responsive">
		<v-container fluid py-0>
			<v-layout justify-space-between align-center>
				<v-flex xs1 class="wrapper-btn-siderbar">
					<button
						@click="$emit('open-sidebar')"
						class="btn-siderbar">
						<img
							v-if="mini"
							src="/static/img/sidebar/menu.svg"
							alt="menu-bars"
							width="19px"
						>
						<img
							v-else
							src="/static/img/sidebar/close.svg"
							alt="menu-bars"
							width="19px"
							height="13px"
						>
					</button>
				</v-flex>
				<v-flex text-xs-right>
					<div class="flex-item justify-end align-center">
						<router-link
							v-if="planAlert"
							:to="{ name: 'your_plan' }"
							class="plan-alert"
							:class="planAlert.className">
							<v-icon small color="white">error_outline</v-icon>
							{{ planAlert.label }}
						</router-link>
						<!-- * Boton para mostrar los pendientes -->
					<v-menu
							:nudge-width="340"
							:close-on-content-click="false"
							offset-y
							left
							attach
							transition="slide-y-transition"
							content-class="hb-menu">
														<button
								slot="activator"
								type="button"
								class="hb-btn hb-btn--pending"
								:class="{ 'hb-btn--alert': pendingTotal > 0 }"
								@click="loadPendingDocuments">
								<span class="hb-btn__icon"><v-icon small>pending_actions</v-icon></span>
								<span class="hb-btn__label">Por contabilizar</span>
								<span v-if="pendingTotal > 0" class="hb-btn__badge">
									{{ pendingTotal > 99 ? '99+' : pendingTotal }}
								</span>
								<span v-else class="hb-btn__zero"><v-icon small>check</v-icon></span>
							</button>
							<v-card class="hb-card">
								<div class="hb-card__header hb-card__header--pending">
									<div>
										<span class="hb-card__eyebrow">Documentos</span>
										<div class="hb-card__title">Pendientes por contabilizar</div>
									</div>
									<div class="hb-card__total">
										<strong>{{ pendingTotal }}</strong>
										<span>en total</span>
									</div>
								</div>
								<div class="hb-card__body">
									<div v-if="loadingPending" class="hb-empty">
										<v-progress-circular indeterminate size="20" width="2" color="amber darken-2" />
										<span>Consultando módulos…</span>
									</div>
									<template v-else>
										<div
											v-for="item in pendingModules"
											:key="item.moduleCode"
											class="hb-row"
											:class="{ 'hb-row--zero': !item.pending }">
											<span class="hb-row__icon" :style="{ background: item.bg, color: item.fg }">
												<v-icon small>{{ item.icon }}</v-icon>
											</span>
											<span class="hb-row__name">{{ item.name }}</span>
											<v-tooltip v-if="item.error" left>
												<v-icon slot="activator" small class="hb-row__error">error_outline</v-icon>
												<span>No se pudo consultar este módulo</span>
											</v-tooltip>
											<span class="hb-row__count">{{ item.pending }}</span>
										</div>
										<div v-if="!pendingModules.length" class="hb-empty">Sin información</div>
									</template>
								</div>
								<div class="hb-card__footer">
									<span>{{ pendingTotal ? 'Hay documentos sin asiento contable' : 'Todo está contabilizado' }}</span>
									<button type="button" class="hb-link" :disabled="loadingPending" @click="loadPendingDocuments">
										<v-icon small>refresh</v-icon> Actualizar
									</button>
								</div>
							</v-card>
						</v-menu>

						<!-- * Asientos contables por módulo -->
						<v-menu
							:nudge-width="380"
							offset-y
							left
							attach
							transition="slide-y-transition"
							content-class="modern-notification-menu">
														<button
								slot="activator"
								type="button"
								class="hb-btn hb-btn--seats"
								:class="{ 'hb-btn--alert': seatsPendingTotal > 0 }"
								@click="loadDataAccounts">
								<span class="hb-btn__icon"><v-icon small>auto_stories</v-icon></span>
								<span class="hb-btn__label">Asientos contables</span>
								<span v-if="seatsPendingTotal > 0" class="hb-btn__badge">
									{{ seatsPendingTotal > 99 ? '99+' : seatsPendingTotal }}
								</span>
								<span v-else class="hb-btn__zero"><v-icon small>check</v-icon></span>
							</button>
							<v-card class="modern-notification-card">
								<v-card-title class="modern-card-header">
									<v-icon left color="white">auto_stories</v-icon>
									<v-toolbar-title class="modern-notification-title">Asientos Contabilizados por Módulos </v-toolbar-title>
									<v-spacer></v-spacer>
								</v-card-title>
								<v-card-text class="px-0 py-0 modern-notification-list">
									<div
										class="modern-notification-item"
										v-for="(item, index) in dataAccounts"
										:key="index">
										<div class="modern-notification-item-header">
											<v-icon :class="[item.color, 'white--text', 'modern-notification-item-header-avatar']">{{item.icon}}</v-icon>
											<span class="modern-notification-item-header-title">
												{{ item.module_name }}
											</span>
										</div>
										<div class="modern-notification-item-content">
											<v-layout wrap row class="modern-notification-item-content-items">
												<v-flex xs12>
													<span class="subtitle-item text-center">Asientos Contables</span>
												</v-flex>
												<v-flex xs6>
													<span class="subtitle-item">Pendientes:</span>
													<span class="subtitle-item">{{ item.pending_count }}</span>
												</v-flex>
												<v-flex xs6>
													<span class="subtitle-item">Confirmados: </span>
													<span class="subtitle-item">{{ item.confirmed_count }}</span>
												</v-flex>
											</v-layout>
											<v-layout wrap row class="modern-notification-item-content-items">
												<v-flex xs12 >
													<span class="subtitle-item text-center">Asientos Pendientes</span>
												</v-flex>
												<v-flex xs6>
													<span class="subtitle-item ">Debe:</span>
													<span class="subtitle-item green-text">{{ item.pending_total_debe || 0 | formatAmount }}</span>
												</v-flex>
												<v-flex xs6>
													<span class="subtitle-item ">Haber: </span>
													<span class="subtitle-item red-text">{{ item.pending_total_haber || 0 | formatAmount }}</span>
												</v-flex>
											</v-layout>
											<v-layout wrap row class="modern-notification-item-content-items">
												<v-flex xs12 >
													<span class="subtitle-item text-center">Asientos Confirmados</span>
												</v-flex>
												<v-flex xs6>
													<span class="subtitle-item">Debe:</span>
													<span class="subtitle-item  green-text">{{ item.confirmed_total_debe || 0 | formatAmount }}</span>
												</v-flex>
												<v-flex xs6>
													<span class="subtitle-item">Haber:</span>
													<span class="subtitle-item red-text">{{ item.confirmed_total_haber || 0 | formatAmount }}</span>
												</v-flex>
											</v-layout>
										</div>
									</div>
								</v-card-text>
							</v-card>
						</v-menu>
						<div class="company-switcher">
							<v-tooltip bottom v-if="$route.name !== 'journal'">
								<button
									slot="activator"
									type="button"
									class="company-add"
									aria-label="Crear una empresa"
									@click="goToNewCompany"
								>
									<v-icon dark small>add</v-icon>
								</button>
								<span>Crear una empresa</span>
							</v-tooltip>
							<!-- La empresa solo se cambia desde Principal; aquí solo se muestra. -->
							<div
								class="company-pill company-pill--readonly"
								:class="{ 'company-pill--empty': !currentSubsidiary.name }"
								:title="currentSubsidiary.name || 'Sin empresa seleccionada'"
							>
								<v-icon small class="company-pill-icon" aria-hidden="true">business</v-icon>
								<span class="company-pill-name">{{ currentSubsidiary.name || 'Sin empresa seleccionada' }}</span>
							</div>
							<v-tooltip bottom v-if="$route.name !== 'main' && !$route.meta.noChangeCompany">
								<button
									slot="activator"
									type="button"
									class="company-change"
									aria-label="Cambiar empresa"
									@click="goToChangeCompany"
								>
									<v-icon small aria-hidden="true">swap_horiz</v-icon>
									<span class="company-change-text">Cambiar empresa</span>
								</button>
								<span>Elegir otra empresa en Principal</span>
							</v-tooltip>
						</div>
						<v-menu>
							<button
								type="button"
								slot="activator"
							>
								<div class="add-btn-wrapper">
									<div class="add-btn-icon">
										<v-icon dark>arrow_drop_down</v-icon>
									</div>
									<p class="add-btn-text">Acciones</p>
								</div>
							</button>
							<v-list>
								<v-list-tile v-if="canManageUsers" :to="{ name: 'users' }">
									<v-list-tile-title>Usuarios y empresas</v-list-tile-title>
								</v-list-tile>
								<router-link
									class="company-modules-route"
									v-for="(item, index) in shortcuts"
									:key="index"
									:disabled="noSubsidiarySelected"
									:to="getRoute(item)"
								>
									<v-list-tile>

										<app-tooltip-button
											class="no-movil"
											:img="item.icon"
											:text="item.title"
										/>

										{{ item.title }}
									</v-list-tile>
								</router-link>
							</v-list>
						</v-menu>
						<div class="separate"></div>
						<div class="profile-image-container">
							<button @click="showMenu = !showMenu" tabindex="-1" class="d-flex account-trigger" :class="{ 'account-trigger--open': showMenu }">
								<img
									class="mr-2"
									:src="userAvatar"
									alt="Imagen de Perfil de Usuario"
									height="20"
									width="20"
								>
								<span class="user-name">{{userName || 'Nombre del Usuario'}}</span>
								<v-icon small class="account-caret" aria-hidden="true">expand_more</v-icon>
							</button>
							<div v-if="showMenu" class="account-backdrop" @click="showMenu = false"></div>
							<div class="content-menu" v-if="showMenu" role="menu">
								<div class="account-card">
									<span class="account-avatar" aria-hidden="true">{{ profileInitial }}</span>
									<div class="account-identity">
										<strong>{{ userName || 'Nombre del Usuario' }}</strong>
										<span v-if="profileEmail" class="account-mail">{{ profileEmail }}</span>
										<span class="account-role" :class="{ 'account-role--admin': canManageUsers }">
											<v-icon small aria-hidden="true">{{ canManageUsers ? 'verified_user' : 'person_outline' }}</v-icon>
											{{ canManageUsers ? 'Contador administrador' : 'Auxiliar contable' }}
										</span>
									</div>
								</div>
								<button class="account-item" role="menuitem" @click="goToProfile">
									<v-icon small aria-hidden="true">account_circle</v-icon>
									<span>Mi perfil</span>
									<v-icon small class="account-item-caret" aria-hidden="true">chevron_right</v-icon>
								</button>
								<button class="account-item account-item--danger" role="menuitem" @click.prevent="askLogout">
									<v-icon small aria-hidden="true">power_settings_new</v-icon>
									<span>Cerrar sesión</span>
								</button>
							</div>
						</div>
					</div>
				</v-flex>
			</v-layout>
			<v-dialog v-model="confirmLogout" content-class="logout-dialog" max-width="420" persistent>
				<v-card class="logout-card">
					<div class="logout-icon"><v-icon>power_settings_new</v-icon></div>
					<h3 class="logout-title">¿Cerrar sesión?</h3>
					<p class="logout-text">Se cerrará tu sesión en este navegador. Tendrás que ingresar tus credenciales para volver a entrar.</p>
					<div class="logout-actions">
						<button type="button" class="logout-btn logout-btn--ghost" :disabled="loggingOut" @click="confirmLogout = false">Cancelar</button>
						<button type="button" class="logout-btn logout-btn--danger" :disabled="loggingOut" @click="logout">
							{{ loggingOut ? 'Cerrando…' : 'Sí, cerrar sesión' }}
						</button>
					</div>
				</v-card>
			</v-dialog>
		</v-container>
	</v-toolbar>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import currentSubsidiaryStorage from '@/shared/current-subsidiary';
import appTooltipButton from '@/components/shared/app-tooltip-button';

const PENDING_MODULE_STYLE = {
	VENTA: { icon: 'sell', bg: '#fdecec', fg: '#d64545' },
	CVENTA: { icon: 'price_check', bg: '#fdf0e7', fg: '#c2410c' },
	COMPRA: { icon: 'shopping_bag', bg: '#fff4e5', fg: '#d97706' },
	CTAXPAG: { icon: 'payments', bg: '#e6f4f1', fg: '#0f766e' },
	CTAXPAGFAC: { icon: 'request_quote', bg: '#e6f4f1', fg: '#0f766e' },
	CTAXCOB: { icon: 'paid', bg: '#e7f6f6', fg: '#02979b' },
	CTAXCOBFAC: { icon: 'receipt_long', bg: '#e7f6f6', fg: '#02979b' },
	ANT: { icon: 'savings', bg: '#f1ecfd', fg: '#6d28d9' },
	INGRESOS: { icon: 'trending_up', bg: '#f2f8e3', fg: '#65a30d' },
	EGRESOS: { icon: 'trending_down', bg: '#eef2f6', fg: '#475569' },
	CAJA: { icon: 'point_of_sale', bg: '#e8f1fd', fg: '#2563eb' },
	BANCO: { icon: 'account_balance', bg: '#fbeaea', fg: '#b91c1c' },
	NOMINA: { icon: 'assignment_ind', bg: '#fef7e0', fg: '#ca8a04' },
};
const DEFAULT_MODULE_STYLE = { icon: 'description', bg: '#f1f5f9', fg: '#475569' };

async function created() {
	const dataUserInfo = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	console.log('dataUserInfo::: ', dataUserInfo);
	this.subsidiaryId = dataUserInfo.subsidiary.id;
	const [remoteLimit] = await Promise.all([
		currentSubsidiaryStorage.fetchRemoteLimit(this.$http),
		this.$loadSubsidiaries({ context: this, params: {} }),
	]);
	// La empresa guardada debe seguir entre las que el usuario puede ver y el plan permite.
	const saved = this.currentSubsidiary;
	const allowed = currentSubsidiaryStorage.allowedIds(
		this.getGlobalSubsidiaries, this.$userInfo, remoteLimit);
	if (saved && saved.id && !allowed.has(Number(saved.id))) {
		this.$setCurrentSubsidiary({});
		if (this.$route.name !== 'main') {
			this.$router.push({ name: 'main' });
		}
	}
	const { subsidiaryId, subsidiaryName } = this.$route.params;
	if (subsidiaryId && subsidiaryName && allowed.has(Number(subsidiaryId))) {
		const id = Number(subsidiaryId);
		const currentSubsidiary = this.getGlobalSubsidiaries.find(sub => sub.id === id);
		this.$setCurrentSubsidiary(currentSubsidiary);
	} else if (this.getGlobalSubsidiaries.length === 1) {
		const currentSubsidiary = this.getGlobalSubsidiaries.find(sub => sub.companyId != null);
		this.$setCurrentSubsidiary(currentSubsidiary);
	}
	console.log('this.$userInfo::: ', this.$userInfo);
	this.loadDataAccounts();
	this.loadPendingDocuments();
}

function openNotifications() {
	this.$emit('open-notifications-event');
}

function goToProfile() {
	this.showMenu = false;
	if (this.$route.name !== 'profile') {
		this.$router.push({ name: 'profile' });
	}
}

async function loadDataAccounts() {
	const params = {
		subsidiaryId: this.subsidiaryId,
	};
	try {
		const { data: response } = await this.$http.post('processing-store-seats-totals', null, { params });
		this.dataAccounts = response.map((r) => {
			const newR = { ...r };
			if (r.module_name === 'BANCO') {
				newR.icon = 'account_balance';
				newR.color = 'red darken-2';
			}
			if (r.module_name === 'CAJA') {
				newR.icon = 'point_of_sale';
				newR.color = 'blue lighten-1';
			}
			if (r.module_name === 'COMPRAS') {
				newR.icon = 'shopping_bag';
				newR.color = 'orange darken-2';
			}
			if (r.module_name === 'CONTABILIDAD') {
				newR.icon = 'calculate';
				newR.color = 'indigo darken-4';
			}
			if (r.module_name === 'CUENTAS POR COBRAR') {
				newR.icon = 'paid';
				newR.color = 'teal lighten-2';
			}
			if (r.module_name === 'CUENTAS POR PAGAR') {
				newR.icon = 'paid';
				newR.color = 'teal darken-3';
			}
			if (r.module_name === 'EGRESOS') {
				newR.icon = 'trending_down';
				newR.color = 'blue-grey accent-2';
			}
			if (r.module_name === 'INGRESOS') {
				newR.icon = 'trending_up';
				newR.color = 'lime darken-2';
			}
			if (r.module_name === 'NOMINA') {
				newR.icon = 'assignment_ind';
				newR.color = 'yellow darken-1';
			}
			if (r.module_name === 'VENTAS') {
				newR.icon = 'sell';
				newR.color = 'red accent-2';
			}
			return newR;
		});
		this.isPendings = this.dataAccounts.some(d => Number(d.pending_count) > 0);
	} catch (error) {
		this.showGenericError();
	}
}
async function loadPendingDocuments() {
	if (this.loadingPending) return;
	const token = this.getCompanyAclToken();
	if (!token) {
		this.pendingModules = [];
		this.pendingTotal = 0;
		return;
	}
	this.loadingPending = true;
	const params = {};
	if (this.makiSubsidiaryId) {
		params.comSubsidiaryId = this.makiSubsidiaryId;
	}
	try {
		const { data: response } = await this.$httpSales.get('check-document-pending/count', {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		this.pendingTotal = Number(response.total) || 0;
		this.pendingModules = (response.modules || []).map(m => ({
			...m,
			...(PENDING_MODULE_STYLE[m.moduleCode] || DEFAULT_MODULE_STYLE),
		}));
	} catch (error) {
		this.showGenericError();
	} finally {
		this.loadingPending = false;
	}
}
function getCompanyAclToken() {
	try {
		const user = typeof this.$userInfo === 'string'
			? JSON.parse(this.$userInfo) : this.$userInfo;
		const acl = (user && user.subsidiary.filters.aclCredentials.company) || {};
		return acl.hash || acl.token || null;
	} catch (error) {
		return null;
	}
}
function askLogout() {
	this.showMenu = false;
	this.confirmLogout = true;
}

async function logout() {
	if (this.loggingOut) return;
	this.loggingOut = true;
	const token = this.token;
	try {
		window.localStorage.clear();
		await this.$httpAcl.post('logout', {
			headers: {
				authorization: `Bearer ${token}`,
			},
		});
	} catch (error) {
		this.loggingOut = false;
	}
	this.confirmLogout = false;
	this.$clearUser();
	this.$router.push({ name: 'login' });
}

function goToChangeCompany() {
	if (this.$route.name !== 'main') {
		this.$router.push({ name: 'main' });
	}
}

function goToNewCompany() {
	if (this.$route.name === 'companies') {
		this.goTo('company-new', { params: { ...this.$route.params } });
	} else {
		this.goTo('company-new');
	}
}

function noSubsidiarySelected() {
	return !(this.currentSubsidiary && this.currentSubsidiary.name);
}

function getRoute({ route }) {
	if (!this.noSubsidiarySelected) {
		if (route === 'costs-centers') {
			const { id, name } = this.currentSubsidiary;
			return { name: route, query: { subsidiaryId: id, subsidiaryName: name.split(' ').join('-') } };
		} else if (route === 'accounting-modules') {
			const { id, name, customerId } = this.currentSubsidiary;
			return { name: 'accounting-modules', query: { subsidiaryId: id, name, customerId } };
		} else if (route === 'accounting-periods') {
			const { id: subsidiaryId, name } = this.currentSubsidiary;
			const subsidiaryName = name.split(' ').join('-');
			return { name: 'accounting-periods', params: { subsidiaryId, subsidiaryName } };
		} else if (route === 'accounting-plans') {
			const { id } = this.currentSubsidiary;
			return { name: 'accounting-plans', params: { subsidiaryId: id } };
		}
	}
	return '';
}

function planAlert() {
	try {
		const user = typeof this.$userInfo === 'string'
			? JSON.parse(this.$userInfo) : this.$userInfo;
		const acl = (user && user.companyAcl) || {};
		const plan = acl.plan || acl.selectPlans;
		if (!plan || !plan.end_date) {
			return null;
		}
		const end = new Date(String(plan.end_date).replace(' ', 'T'));
		if (Number.isNaN(end.getTime())) {
			return null;
		}
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		const days = Math.ceil((end.getTime() - today.getTime()) / 86400000);
		if (days < 0) {
			return { className: 'plan-alert--expired', label: 'Plan vencido' };
		}
		const notice = Number(plan.days_notification) || 0;
		if (notice > 0 && days <= notice) {
			return {
				className: 'plan-alert--warning',
				label: days === 0 ? 'Tu plan vence hoy' : `Tu plan vence en ${days} días`,
			};
		}
		return null;
	} catch (error) {
		return null;
	}
}

function data() {
	return {
		showMenu: false,
		shortcuts: [
			{ icon: '/static/img/icons/centro-costos.svg', title: 'Centro de costos', route: 'costs-centers' },
			{ icon: '/static/img/icons/plan-contable.svg', title: 'Plan contable', route: 'accounting-plans' },
			{ icon: '/static/img/icons/periodo-contable.svg', title: 'Periodos contables', route: 'accounting-periods' },
			{ icon: '/static/img/icons/modulo.svg', title: 'Modulos', route: 'accounting-modules' },
		],
		confirmLogout: false,
		pendingModules: [],
		pendingTotal: 0,
		loadingPending: false,
		loggingOut: false,
		subsidiaryId: null,
		dataAccounts: [],
		isPendings: false,
	};
}

export default {
	name: 'app-header',
	components: {
		appTooltipButton,
	},
	computed: {
		planAlert,
		profileInitial() {
			return (this.userName || '?').trim().slice(0, 1).toUpperCase();
		},
		seatsPendingTotal() {
			return (this.dataAccounts || []).reduce((acc, d) => acc + (Number(d.pending_count) || 0), 0);
		},
		makiSubsidiaryId() {
			const sub = this.currentSubsidiary || {};
			return sub.externalId || null;
		},
		profileEmail() {
			try {
				const user = typeof this.$userInfo === 'string'
					? JSON.parse(this.$userInfo) : this.$userInfo;
				return (user && user.auxiliary && user.auxiliary.email) || '';
			} catch (error) {
				return '';
			}
		},
		canManageUsers() {
			try {
				const user = typeof this.$userInfo === 'string'
					? JSON.parse(this.$userInfo) : this.$userInfo;
				return !!(user && user.auxiliary && [true, 1].includes(user.auxiliary.flagAccountant));
			} catch (error) {
				return false;
			}
		},
		...mapGetters('user', [
			'userAvatar',
			'userName',
		]),
		...mapGetters('subsidiary', [
			'currentSubsidiary',
			'getGlobalSubsidiaries',
		]),
		noSubsidiarySelected,
	},
	created,
	data,
	methods: {
		...mapActions('user', {
			$clearUser: 'clearUser',
		}),
		...mapActions('subsidiary', {
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
			$loadSubsidiaries: 'loadSubsidiaries',
		}),
		getRoute,
		logout,
		openNotifications,
		goToNewCompany,
		goToProfile,
		askLogout,
		goToChangeCompany,
		loadDataAccounts,
		getCompanyAclToken,
		loadPendingDocuments,
	},
	props: {
		quantityNotifications: {
			default: 0,
			type: Number,
		},
		mini: Boolean,
	},
	watch: {
		'currentSubsidiary.id': function onSubsidiaryChange() {
			this.loadPendingDocuments();
		},
	},
};
</script>

<style lang="scss" scoped>
.header-style {
	box-shadow: 0 2px 4px 0 rgba(206, 206, 206, 0.5) !important;
}

.container {
	height: 100%;
	@media (max-width: 599px) {
		margin-left: 0px !important;
		margin-right: 0px !important;
	}

	.layout {
		height: 100%;
	}

	@media (max-width: 959px) {
		padding: 10px
	}
}

.v-toolbar {
	background-color:  #fff;
	box-shadow: none;
	height: 40px;
}
.theme--light.v-toolbar {
	background-color: #02979b!important;
}

.flex-item {
	display: flex;
}

.profile {
	&-name {
		color: map-get($colors, black);
		font-family: map-get($fonts, open-bold);
		font-size: 13px;
		font-weight: bold;
		padding-right: 9px;
		vertical-align: super;
	}

	&-image-container {
		align-items: center;
		border-radius: 100%;
		display: inline-flex;
		font-size: map-get($sizes, small);
		height: 20px;
		justify-content: center;
	}
}

.notification {
	&-btn {
		background-color: transparent !important;
		border-radius: 0px;
		box-shadow: none;
		height: auto;
		margin: 0px 25px 0px 0px;
		max-height: 40px;
		min-width: auto;
		width: auto;
	}

	&-quantity {
		background-color: map-get($colors, border);
		border-radius: 100%;
		color: white;
		font-family: map-get($fonts, lato-regular);
		font-size: map-get($sizes, small10);
		height: 12px;
		right: 15px;
		line-height: 10px;
		position: absolute;
		text-align: center;
		top: 8px;
		width: 12px;
		z-index: 2;
	}
}

.btn-notification {
	color: map-get($colors, base) !important;

	.v-icon {
		color: inherit !important;
	}
}

.separate {
	border: solid 1px color(grey);
	height: 25px;
	margin: 0 10px;
}

.add-btn-container {
	background-color: #02979b!important;
	border-radius: 50%;
	@media (max-width: 768px) {
		background-color: #33cfc7!important;
	}
}

.company-switcher {
	align-items: center;
	display: flex;
	gap: 8px;
	margin-right: 16px;
	min-width: 0;
	position: relative;
}
.company-add {
	align-items: center;
	background: #02979b;
	border-radius: 50%;
	box-shadow: 0 2px 6px rgba(2, 151, 155, 0.3);
	display: inline-flex;
	flex: 0 0 auto;
	height: 30px;
	justify-content: center;
	transition: background-color 0.15s ease, transform 0.15s ease;
	width: 30px;
	.v-icon { color: #fff !important; }
	&:hover { background: #037f83; transform: translateY(-1px); }
	&:focus-visible { outline: 2px solid color(secondary); outline-offset: 2px; }
	@media (max-width: 768px) { background: #33cfc7; }
}

.user-name {
	color: color(secondary) !important;
	white-space: nowrap;
}

.select {
	max-width: 320px;
	min-width: 220px;
}
.company-pill {
	align-items: center;
	background: #fff;
	border: 1px solid rgba(2, 151, 155, 0.35);
	border-radius: 999px;
	color: color(black);
	display: flex;
	font-family: font(AvenirBold);
	font-size: 13px;
	gap: 8px;
	height: 34px;
	max-width: 320px;
	min-width: 0;
	padding: 0 12px;
	transition: border-color 0.15s ease, box-shadow 0.15s ease;
	&:hover:not(:disabled) { border-color: rgba(2, 151, 155, 0.7); }
	&:focus-visible { outline: 2px solid #02979b; outline-offset: 2px; }
}
.company-pill-icon { color: #02979b !important; flex: 0 0 auto; }
.company-pill-name {
	flex: 1 1 auto;
	min-width: 0;
	overflow: hidden;
	text-align: left;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.company-pill-caret { color: rgba(15, 42, 68, 0.45) !important; flex: 0 0 auto; }
.company-pill--empty .company-pill-name {
	color: rgba(15, 42, 68, 0.45);
	font-family: font(AvenirRegular);
}
.company-pill--readonly {
	background: rgba(2, 151, 155, 0.06);
	cursor: default;
}
.company-change {
	align-items: center;
	background: transparent;
	border: 1px solid rgba(2, 151, 155, 0.35);
	border-radius: 999px;
	color: #02979b;
	display: inline-flex;
	flex: 0 0 auto;
	font-family: font(AvenirBold);
	font-size: 12px;
	gap: 4px;
	height: 34px;
	padding: 0 12px;
	transition: background-color 0.15s ease, border-color 0.15s ease;
	.v-icon { color: #02979b !important; }
	&:hover { background: rgba(2, 151, 155, 0.08); border-color: rgba(2, 151, 155, 0.7); }
	&:focus-visible { outline: 2px solid #02979b; outline-offset: 2px; }
	@media (max-width: 768px) {
		padding: 0 8px;
		.company-change-text { display: none; }
	}
}
.company-pill--locked {
	background: rgba(15, 42, 68, 0.04);
	border-style: dashed;
	cursor: default;
	.company-pill-name { color: rgba(15, 42, 68, 0.45); }
	.company-pill-caret { display: none; }
}

.company-menu {
	border: 1px solid rgba(15, 42, 68, 0.08) !important;
	border-radius: 14px !important;
	box-shadow: 0 18px 38px rgba(15, 42, 68, 0.16) !important;
	max-width: 340px !important;
	min-width: 240px !important;
	overflow: hidden;
}
.company-list { padding: 6px !important; }
.company-option {
	border-radius: 10px;
	margin-bottom: 2px;
	.v-list__tile {
		align-items: center;
		border-radius: 10px;
		display: flex;
		gap: 10px;
		height: auto !important;
		min-height: 40px;
		padding: 0 12px !important;
	}
	.v-icon { color: rgba(15, 42, 68, 0.5) !important; }
	&:hover .v-list__tile { background: rgba(2, 151, 155, 0.08); }
}
.company-option-name {
	flex: 1 1 auto;
	font-size: 13px;
	min-width: 0;
	overflow-wrap: anywhere;
	white-space: normal;
}
.company-option--active {
	.v-list__tile { background: rgba(2, 151, 155, 0.12); }
	.company-option-name { font-family: font(AvenirBold); }
	.v-icon { color: #02979b !important; }
}

@media (max-width: 954px) {
	.company-switcher { margin-right: 8px; }
	.select { min-width: 150px; }
}

.header-responsive {
	@media (max-width: 954px) {
		border-bottom: 3px solid #006edb;
		padding-left: 0px !important;
		.separate, .profile-image-container {
			display: none;
		}
	}
}

.logo-quipu-image {
	&:focus {
		outline: none;
	}
}

.wrapper-btn-siderbar {
	border-right: 1px solid map-get($colors, grey-icon);
	margin-right: 12px;
	padding: 4px 10px 0 0;

	@media (min-width: 768px) {
		display: none;
	}
}
.plan-alert {
	align-items: center;
	border-radius: 12px;
	color: #fff !important;
	display: inline-flex;
	font-size: 12px;
	font-weight: 600;
	gap: 4px;
	margin-right: 12px;
	padding: 2px 10px;
	text-decoration: none;
	white-space: nowrap;
}
.plan-alert .v-icon {
	margin-right: 4px;
}
.plan-alert--expired {
	background-color: #c0392b;
}
.plan-alert--warning {
	background-color: #e67e22;
}
.company-modules-route {
	text-decoration: none;
	width: 100%;

	&[disabled] {
		cursor: not-allowed;
	}
}
.add-btn {
	&-wrapper {
		align-items: center;
		display: flex;
	}
	&-icon {
		background-color: color('btn-green');
		border-radius: 50%;
		height: 28px;
		margin-left: 5px;
		width: 28px;

		@media (min-width: 768px) {
			margin-left: 0px;
			transform: translateX(18px);
		}
	}
	&-text {
		display: none;

		@media (min-width: 768px) {
			background-color: #b2dd00 !important;
			border-radius: 17px;
			color: white;
			font-weight: bold;
			display: block;
			font-size: 12px;
			padding: 0.1rem 1rem;
			padding-left: 1.65rem;
			margin-bottom: 0;
		}
	}
}
.profile-image-container {
	position: relative;
}
.add-btn-icon {
	background-color: #02979b!important;
	@media (max-width: 768px) {
		background-color: #33cfc7 !important;
	}
}

.account-trigger {
	align-items: center;
	border-radius: 999px;
	padding: 3px 10px 3px 6px;
	transition: background-color 0.18s ease;
	&:hover, &.account-trigger--open { background: rgba(0, 110, 219, 0.08); }
	&:focus-visible { outline: 2px solid color(secondary); outline-offset: 2px; }
}
.account-caret {
	margin-left: 4px;
	color: color(secondary) !important;
	transition: transform 0.18s ease;
	.account-trigger--open & { transform: rotate(180deg); }
}
.account-backdrop {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 399;
}

.content-menu {
	background: #fff;
	border: 1px solid rgba(15, 42, 68, 0.08);
	border-radius: 14px;
	box-shadow: 0 18px 38px rgba(15, 42, 68, 0.16), 0 2px 6px rgba(15, 42, 68, 0.06);
	color: color(text);
	font-size: 13px;
	overflow: hidden;
	padding: 6px;
	position: absolute;
	right: 0;
	top: calc(100% + 12px);
	width: 268px;
	z-index: 400;
	animation: account-menu-in 0.16s ease-out;
}
@keyframes account-menu-in {
	from { opacity: 0; transform: translateY(-6px); }
	to { opacity: 1; transform: translateY(0); }
}
.account-card {
	align-items: center;
	background: linear-gradient(135deg, rgba(0, 110, 219, 0.08), rgba(2, 151, 155, 0.08));
	border-radius: 10px;
	display: flex;
	gap: 10px;
	margin-bottom: 6px;
	padding: 12px;
}
.account-avatar {
	align-items: center;
	background: color(secondary);
	border-radius: 50%;
	color: #fff;
	display: inline-flex;
	flex: 0 0 auto;
	font-size: 16px;
	font-weight: 700;
	height: 38px;
	justify-content: center;
	width: 38px;
}
.account-identity {
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
	strong { color: color(black); font-size: 13px; line-height: 1.25; overflow-wrap: anywhere; }
}
.account-mail {
	color: rgba(15, 42, 68, 0.6);
	font-size: 11px;
	overflow-wrap: anywhere;
}
.account-role {
	align-items: center;
	color: rgba(15, 42, 68, 0.75);
	display: inline-flex;
	font-size: 11px;
	gap: 4px;
	margin-top: 2px;
	.v-icon { font-size: 13px !important; color: inherit !important; }
}
.account-role--admin { color: color(secondary); }
.account-item {
	align-items: center;
	background: transparent;
	border-radius: 10px;
	color: color(text);
	display: flex;
	font-size: 13px;
	gap: 10px;
	padding: 10px 12px;
	text-align: left;
	transition: background-color 0.15s ease;
	width: 100%;
	span { flex: 1; }
	.v-icon { color: rgba(15, 42, 68, 0.55) !important; font-size: 18px !important; }
	&:hover { background: rgba(0, 110, 219, 0.08); }
	&:focus-visible { outline: 2px solid color(secondary); outline-offset: -2px; }
}
.account-item-caret { opacity: 0; transition: opacity 0.15s ease; }
.account-item:hover .account-item-caret { opacity: 1; }
.account-item--danger {
	border-top: 1px solid rgba(15, 42, 68, 0.08);
	border-radius: 0 0 10px 10px;
	color: #c0392b;
	margin-top: 4px;
	.v-icon { color: #c0392b !important; }
	&:hover { background: rgba(192, 57, 43, 0.08); }
}

.logout-dialog { border-radius: 16px; }
.logout-card {
	border-radius: 16px;
	padding: 28px 24px 22px;
	text-align: center;
}
.logout-icon {
	align-items: center;
	background: rgba(192, 57, 43, 0.1);
	border-radius: 50%;
	display: inline-flex;
	height: 56px;
	justify-content: center;
	margin-bottom: 14px;
	width: 56px;
	.v-icon { color: #c0392b !important; font-size: 28px !important; }
}
.logout-title {
	color: color(black);
	font-size: 19px;
	font-weight: 700;
	margin: 0 0 6px;
}
.logout-text {
	color: rgba(15, 42, 68, 0.65);
	font-size: 13px;
	line-height: 1.5;
	margin: 0 auto 22px;
	max-width: 320px;
}
.logout-actions { display: flex; gap: 12px; justify-content: center; }
.logout-btn {
	border-radius: 10px;
	font-size: 13px;
	font-weight: 600;
	min-width: 130px;
	padding: 11px 18px;
	transition: background-color 0.15s ease, box-shadow 0.15s ease;
	&:disabled { opacity: 0.6; cursor: default; }
	&:focus-visible { outline: 2px solid color(secondary); outline-offset: 2px; }
}
.logout-btn--ghost {
	background: #fff;
	border: 1px solid rgba(15, 42, 68, 0.18);
	color: color(text);
	&:hover:not(:disabled) { background: rgba(15, 42, 68, 0.04); }
}
.logout-btn--danger {
	background: #c0392b;
	color: #fff;
	box-shadow: 0 6px 16px rgba(192, 57, 43, 0.28);
	&:hover:not(:disabled) { background: #a93226; }
}

.title-data {
	background-color: #00897b;
	color: #fff;
}


.modern-notification-menu {
	border-radius: 16px !important;
	box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
	border: 1px solid rgba(2, 151, 155, 0.1) !important;
	backdrop-filter: blur(10px);
}
.modern-notification-card {
	border-radius: 10px;
	overflow: hidden;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1) !important;
}
.modern-card-header {
	background: linear-gradient(135deg, #02979B 0%, #028a94 100%) !important;
	color: white !important;
	padding: 12px;
}
.modern-notification-title {
	font-weight: 600 !important;
	font-size: 16px !important;
	color: white !important;
}
.modern-notification-list {
	max-height: 500px;
	overflow-y: scroll;
	&::-webkit-scrollbar {
		width: 1px;
	}
	.modern-notification-item {
		display: flex;
		justify-content: start !important;
		flex-direction: column;
		padding: 5px !important;
		border-bottom: 1px solid rgba(2, 151, 155, 0.05) !important;
		transition: all 0.2s ease;
		&:hover {
			background: linear-gradient(135deg, rgba(2, 151, 155, 0.02) 0%, rgba(2, 151, 155, 0.05) 100%);
			transform: translateX(4px);
		}
		&-header {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			gap: 10px;
			&-avatar {
				padding: 10px;
				border-radius: 50%;
				font-size: medium;
			}
			&-title {
					font-weight: 600 !important;
					font-size: size(small) !important;
					color: color(btn-gray) !important;
					font-family: font(AvenirRegular);
			}
		}
		&-content {
			display: flex;
			justify-content: start !important;
			flex-direction: column;
			width: 100%;
			
			&-items {
				text-align: start;
				padding-top: 5px;
				margin-left: 70px;
			}
		}
	}
}
.subtitle-item {
	font-weight: 600 !important;
	font-size: size(small) !important;
	color: color(btn-gray);
	font-family: font(AvenirRegular);
	padding: 0;
}
.text-center {
	text-align: center !important;
}
.red-text {
	color: color(text-red-light);
}
.green-text {
	color: color(border);
}
.modern-notification-footer {
	padding: 16px 20px !important;

	.modern-total-chip {
		background: linear-gradient(135deg, #02979B 0%, #028a94 100%) !important;
		font-weight: 700 !important;
		font-size: 13px !important;
		border-radius: 20px !important;
	}
}
/* ================= BOTONES DEL HEADER ================= */
/* ================= BOTONES DEL HEADER ================= */
.hb-btn {
	--hb-tone: #02979b;
	--hb-tone-dark: #037f83;
	--hb-glow: rgba(2, 151, 155, 0.45);
	align-items: center;
	background: #ffffff;
	border: 1px solid rgba(15, 42, 68, 0.1);
	border-radius: 999px;
	box-shadow: 0 1px 2px rgba(15, 42, 68, 0.08);
	color: #1e293b;
	cursor: pointer;
	display: inline-flex;
	font-size: 12px;
	font-weight: 600;
	gap: 9px;
	height: 34px;
	margin-right: 10px;
	padding: 0 6px 0 4px;
	position: relative;
	transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
	white-space: nowrap;

	&:hover {
		box-shadow: 0 8px 18px rgba(15, 42, 68, 0.16);
		transform: translateY(-1px);
	}

	&:focus-visible {
		outline: 2px solid #ffffff;
		outline-offset: 2px;
	}

	&__icon {
		align-items: center;
		background: linear-gradient(135deg, var(--hb-tone), var(--hb-tone-dark));
		border-radius: 50%;
		display: inline-flex;
		flex: 0 0 auto;
		height: 26px;
		justify-content: center;
		width: 26px;

		.v-icon {
			color: #ffffff !important;
			font-size: 15px !important;
		}
	}

	&__label {
		letter-spacing: 0.1px;
	}

	&__badge {
		align-items: center;
		background: var(--hb-tone);
		border-radius: 999px;
		color: #ffffff;
		display: inline-flex;
		font-size: 11px;
		font-weight: 700;
		height: 20px;
		justify-content: center;
		min-width: 20px;
		padding: 0 7px;
	}

	&__zero {
		align-items: center;
		color: #94a3b8;
		display: inline-flex;
		justify-content: center;
		min-width: 20px;

		.v-icon {
			color: #94a3b8 !important;
			font-size: 15px !important;
		}
	}

	&--seats {
		--hb-tone: #02979b;
		--hb-tone-dark: #037f83;
		/* el header ya es teal: el halo teal no se veria, va en blanco */
		--hb-glow: rgba(255, 255, 255, 0.75);
	}

	&--pending {
		--hb-tone: #d97706;
		--hb-tone-dark: #b45309;
		--hb-glow: rgba(217, 119, 6, 0.45);
	}

	&--alert {
		animation: hb-pulse 2s ease-in-out infinite;
		border-color: var(--hb-tone);
		color: var(--hb-tone-dark);
	}

	&--alert &__badge {
		animation: hb-beat 2s ease-in-out infinite;
	}

	@media (max-width: 960px) {
		padding-right: 4px;

		.hb-btn__label {
			display: none;
		}
	}
}

@keyframes hb-pulse {
	0% {
		box-shadow: 0 0 0 0 var(--hb-glow);
	}

	65% {
		box-shadow: 0 0 0 9px rgba(255, 255, 255, 0);
	}

	100% {
		box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
	}
}

@keyframes hb-beat {
	0%,
	100% {
		transform: scale(1);
	}

	50% {
		transform: scale(1.16);
	}
}

@media (prefers-reduced-motion: reduce) {
	.hb-btn--alert,
	.hb-btn--alert .hb-btn__badge {
		animation: none;
	}
}

/* ================= MENÚ DE PENDIENTES ================= */
.hb-menu {
	border-radius: 16px !important;
	box-shadow: 0 20px 50px rgba(15, 42, 68, 0.18) !important;
}

.hb-card {
	border-radius: 16px !important;
	overflow: hidden;

	&__header {
		align-items: center;
		color: #fff;
		display: flex;
		justify-content: space-between;
		padding: 14px 16px;

		&--pending { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); }
	}

	&__eyebrow {
		font-size: 10px;
		letter-spacing: 0.1em;
		opacity: 0.85;
		text-transform: uppercase;
	}

	&__title {
		font-size: 15px;
		font-weight: 700;
	}

	&__total {
		align-items: center;
		background: rgba(255, 255, 255, 0.18);
		border-radius: 12px;
		display: flex;
		flex-direction: column;
		min-width: 64px;
		padding: 4px 10px;

		strong { font-size: 20px; line-height: 1.1; }
		span { font-size: 10px; opacity: 0.9; }
	}

	&__body {
		max-height: 380px;
		overflow-y: auto;
		padding: 6px;
	}

	&__footer {
		align-items: center;
		background: #f8fafc;
		border-top: 1px solid rgba(15, 42, 68, 0.08);
		color: #64748b;
		display: flex;
		font-size: 11px;
		justify-content: space-between;
		padding: 8px 14px;
	}
}

.hb-row {
	align-items: center;
	border-radius: 10px;
	display: flex;
	gap: 10px;
	padding: 7px 8px;
	transition: background-color 0.15s ease;

	&:hover { background: #f8fafc; }

	&__icon {
		align-items: center;
		border-radius: 9px;
		display: inline-flex;
		flex: 0 0 auto;
		height: 30px;
		justify-content: center;
		width: 30px;

		.v-icon,
		.icon {
			color: inherit !important;
			font-size: 17px !important;
		}
	}

	&__name {
		color: #1e293b;
		flex: 1;
		font-size: 12px;
		font-weight: 600;
		text-align: left;
	}

	&__error {
		color: #ef4444 !important;
	}

	&__count {
		background: #fff7ed;
		border-radius: 999px;
		color: #c2410c;
		font-size: 12px;
		font-weight: 700;
		min-width: 32px;
		padding: 2px 10px;
		text-align: center;
	}

	&--zero {
		.hb-row__name { color: #94a3b8; }
		.hb-row__count { background: #f1f5f9; color: #94a3b8; }
	}
}

.hb-empty {
	align-items: center;
	color: #94a3b8;
	display: flex;
	font-size: 12px;
	gap: 8px;
	justify-content: center;
	padding: 24px 0;
}

.hb-link {
	align-items: center;
	color: #d97706;
	display: inline-flex;
	font-size: 11px;
	font-weight: 700;
	gap: 4px;

	.v-icon,
	.icon { color: inherit !important; font-size: 15px !important; }

	&:disabled { opacity: 0.5; }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/app-header.vue